import { DrillIcon, DropletIcon, FactoryIcon, GraduationCapIcon, HardHatIcon, LayersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: "Fondamenti dell'Industria del Petrolio e del Gas",
    summary: 'Cosa sono gli idrocarburi, da dove vengono, la catena del valore (upstream, midstream, downstream) e perché il petrolio è ovunque nella vita quotidiana.',
    icon: DropletIcon,
  },
  {
    number: '02',
    title: 'Geologia del Petrolio, Giacimenti ed Esplorazione',
    summary: 'Roccia madre, roccia serbatoio e di copertura, trappole, porosità e permeabilità, metodi di esplorazione e sismica.',
    icon: LayersIcon,
  },
  {
    number: '03',
    title: 'Perforazione, Costruzione dei Pozzi e Produzione',
    summary: 'Come si progetta e si perfora un pozzo, onshore e offshore, completamento, recupero e separazione in superficie.',
    icon: DrillIcon,
  },
  {
    number: '04',
    title: 'Trasporto, Stoccaggio, Raffinazione e Prodotti Petroliferi',
    summary: 'Oleodotti, gasdotti, navi cisterna e GNL, distillazione frazionata e tutti i prodotti che nascono da un barile.',
    icon: FactoryIcon,
  },
  {
    number: '05',
    title: 'Sicurezza, Ambiente, Economia e Transizione Energetica',
    summary: 'Rischi e barriere di sicurezza, impatti e mitigazione, prezzi e mercati, ruolo di petrolio e gas nella transizione energetica.',
    icon: HardHatIcon,
  },
  {
    number: '06',
    title: "Insegnare l'Industria del Petrolio e del Gas",
    summary: 'Errori concettuali degli studenti, analogie efficaci, collegamenti interdisciplinari, lessico essenziale e schede di sintesi per la classe.',
    icon: GraduationCapIcon,
  },
];
